import Ellipsis from '../Ellipsis';
import { TooltipCommonPropTypes } from './TooltipCommon';
export const EllipsisCommonProps = {
    ellipsis: Ellipsis.propTypes.ellipsis,
    showTooltip: Ellipsis.propTypes.showTooltip,
    ...TooltipCommonPropTypes,
};
//# sourceMappingURL=EllipsisCommon.js.map